export default __webpack_public_path__ + "dc6172a7a179dc3b2d3c4224c121cc6b.svg";